import React, { useRef, type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';
import type { Dialog } from '@uncinc/uncinc-react-kitchen-sink';
import useBoolean from '@uncinc/uncinc-react-kitchen-sink/dist/hooks/useBoolean';
import useDialogHelpers from '@uncinc/uncinc-react-kitchen-sink/dist/hooks/useDialogHelpers';

import './style.scss';

export interface DialogConfirmProps extends ComponentProps<typeof Dialog> {
  buttonText?: string;
  buttonIcon?: string;
  onSubmit?: Function;
  className?: string;
  children: React.ReactNode;
}

// export const DialogConfirm = (args) => {
export const DialogConfirm: React.FC<DialogConfirmProps> = (props) => {
  const { t } = useTranslation();
  const {
    buttonText,
    buttonIcon,
    onSubmit = () => { },
    children,
  } = props;

  const {
    value: dialogIsOpen,
    setTrue: openDialog,
    setFalse: closeDialog,
  } = useBoolean();

  const wrapper = useRef(null);

  const {
    dialogHelpersProps,
  } = useDialogHelpers({
    wrapperElement: wrapper,
    closeFunction: closeDialog,
    isOpen: dialogIsOpen,
    disableClosers: false,
  });

  return (
    <div className="Dialog--confirm">
      <button
        type="button"
        className="Button Button--dialog"
        onClick={openDialog}
      >
        <i className={`dialogOpenIcon icon icon-${buttonIcon || 'question-circle'}`} />
        {buttonText}
      </button>
      {dialogIsOpen && (
        <div
          {...dialogHelpersProps}
          className="Dialog"
        >
          <div
            className="Dialog__wrapper"
            ref={wrapper}
          >
            <div className="Dialog__inner">
              {/* Content */}
              {children}

              {/* Actions */}
              <div className="row">
                <div className="col-6">
                  <Button
                    onClick={() => {
                      onSubmit();
                      closeDialog();
                    }}
                  >
                    {buttonText}
                  </Button>
                </div>
                <div className="col-6">
                  <Button
                    className="Button Button--inverted"
                    onClick={closeDialog}
                  >
                    {t('general.cancel')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="Dialog__backdrop"
          />
        </div>
      )}
    </div>
  );
};

export default DialogConfirm;
